import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { MediaUPload } from "@unisearch/common/media";
import PaginationComponent from "@unisearch/common/ui_element/pagination";
import { getAssets, swalConfirm, swalError } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import React, { Fragment, useEffect, useState } from "react";
import { BsCloudUploadFill, BsFillGrid3X2GapFill } from "react-icons/bs";
import { FaSearch, FaTrash } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { HiPlusCircle } from "react-icons/hi";
import { ReactSVG } from "react-svg";
import MediaScreen from "../loader/media_screen";
import { MediaBox } from "../media/MediaBox";
import styles from "./ImageInput.module.scss";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const MyGallery = ({
  name,
  url,
  onChange,
  returnItem,
  value = false,
  component_type = "default",
  guideLine,
  title = "Upload Image",
  allowItem = "image", //"video", "pdf", "docx", "doc", "xlsx"
}) => {
  const [open, setOpen] = React.useState(false);

  //handle open
  const handleOpen = (data) => {
    setOpen(data);
  };

  //handle close
  const handleClose = (e) => {
    e.preventDefault();
    setOpen(false);
  };

  //initial media name and files
  const target_name = name || "featured_image";
  const FILES_URL = `/media-manager/find-mediaFile`;

  const [loading, setLoading] = useState(false);
  const [is_EnableForm, setEnableForm] = useState(false);

  //get Media Data
  const [mediaData, setMediaData] = useState([]);
  const [paginate, setPaginate] = useState({});

  //search search state
  const [searchFields, setSearchFields] = useState({
    filter: { mediaName: "", alt: "", tag: allowItem },
    sortOrder: "DESC",
    sortField: "mediaManagerId",
    pageNumber: 1,
    pageSize: 10,
  });

  const paginationHandler = (event, page) => {
    setSearchFields({ ...searchFields, pageNumber: page });
  };

  //handle serach input
  const handleInput = (e) => {
    const { name, value } = e.target;
    const filter = { ...searchFields.filter, [name]: value };
    setSearchFields({ ...searchFields, filter, pageNumber: 1 });
  };

  const handleOrder = (e) => {
    const { name, value } = e.target;
    setSearchFields({ ...searchFields, [name]: value, pageNumber: 1 });
  };

  //when click on handle serach button
  const handleSearch = async () => {
    //loading true
    setLoading(true);

    //post handle search
    await API.post(`${FILES_URL}`, searchFields)
      .then((response) => {
        if (response.error) {
          swalError("Something Wrong!");
        }

        if (!response.error) {
          const {
            total,
            results,
            currentPage,
            page_total,
            limit,
          } = response.data;

          //set Paginate Info
          setPaginate({ total, currentPage, page_total, limit });

          //set media data
          setMediaData(results);
        }
      })
      .catch((error) => {
        swalError(error);
      });

    //loading false
    setLoading(false);
  };

  //Manage image path
  let placeholder =
    allowItem && allowItem == "video"
      ? "/assets/images/vector-image.png"
      : "/assets/images/vector-image.png";

  const [imageUrl, setImageUrl] = useState(placeholder);
  const [selected, setSelected] = useState();

  const imageChange = (data) => {
    if (selected && selected.mediaManagerId == data.mediaManagerId) {
      setSelected("");
    } else {
      setSelected(data);
    }
  };

  const handleInsert = () => {
    setImageUrl(selected.src);

    //pass parent props
    if (onChange) {
      const target = { name: target_name, value: selected[returnItem] };
      onChange({ target });
    }
    setOpen(false);
  };

  const PreviewImage = (imageUrl) => {
    const extension = imageUrl.split(".").pop();
    if (extension == "pdf") {
      return (
        <ReactSVG
          className={styles.icon}
          src={getAssets("assets/icons/pdf_icon.svg")}
        />
      );
    }

    if (extension == "xlsx" || extension == "xls") {
      return (
        <ReactSVG
          className={styles.icon}
          src={getAssets("assets/icons/xls_icon.svg")}
        />
      );
    }

    if (extension == "docx" || extension == "doc") {
      return (
        <ReactSVG
          className={styles.icon}
          src={getAssets("assets/icons/doc_icon.svg")}
        />
      );
    }

    if (extension == "mp4") {
      return (
        <video width="100%" height="180" controls="controls" preload="none">
          <source src={imageUrl} type="video/mp4" autostart="false" />
          Your browser does not support the video tag.
        </video>
      );
    }

    if (
      extension == "jpg" ||
      extension == "jpeg" ||
      extension == "png" ||
      extension == "webp" ||
      extension == "svg"
    ) {
      return (
        <div className={styles.media_image_wrapper}>
          <img src={imageUrl} alt="" />
          {imageUrl === "/assets/images/vector-image.png" ? (
            <HiPlusCircle className={`admin_upload_image_icon`} />
          ) : null}
        </div>
      );
    }

    return <img src={imageUrl} alt="" />;
  };

  //when change page
  useEffect(() => {
    const fetchData = async () => {
      if (open) {
        await handleSearch();
      }
    };
    fetchData();
  }, [searchFields.pageNumber, searchFields.sortOrder]);

  useEffect(() => {
    const fetchData = async () => {
      if (open && mediaData.length <= 0) {
        await handleSearch();
      }
    };
    fetchData();
  }, [open]);

  //change image url
  useEffect(() => {
    if (url) {
      setImageUrl(url);
    } else {
      setImageUrl(placeholder);
    }
  }, [url, placeholder]);

  //handleList
  const handleList = () => {
    setEnableForm(false);
  };

  //get data form child
  const handleUploaded = async (result) => {
    if (result) {
      setEnableForm(false);
      await handleSearch();
    } else {
      swalError("Upload Error");
    }
  };

  //remove this item
  const handleRemove = async () => {
    if (selected && selected.mediaManagerId) {
      swalConfirm(
        "you want to remove this item?",
        "Are you sure",
        "Yes Remove"
      ).then(async (res) => {
        if (res.isConfirmed) {
          await API.delete(
            `media-manager/delete/${parseInt(selected.mediaManagerId)}`
          ).then(async (res) => {
            const pageNumber =
              paginate.page_total >= 2
                ? paginate.currentPage
                : paginate.currentPage > 1 && paginate.page_total == 1
                ? parseInt(paginate.currentPage - 1)
                : paginate.currentPage;

            //clear selected state
            setSelected("");

            //search again
            setSearchFields({ ...searchFields, pageNumber });

            if (pageNumber == paginate.currentPage) {
              await handleSearch();
            }
          });
        }
      });
    } else {
      swalError("Please select any one media item");
    }
  };

  //remove selected items from state
  const handleClear = () => {
    swalConfirm("Remove this item", "Are you sure", "Yes Delete").then(
      (rsp) => {
        if (rsp.isConfirmed) {
          setImageUrl(placeholder);
          setSelected("");
          if (onChange) {
            const target = { name: "", value: "" };
            onChange({ target });
          }
        }
      }
    );
  };

  return (
    <Fragment>
      <button
        onClick={(e) => handleOpen(true)}
        type="button"
        name={target_name}
        data-srclink={imageUrl ?? 0}
        style={{
          display: "none",
        }}
      />

      {value && value != undefined && value != 0 && (
        <button
          type="button"
          className={styles.clearOld}
          onClick={() => handleClear()}
        >
          <FaTrash /> <span className="hide-sm"></span>
        </button>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.ModalWrapper}>
          <div className={styles.ModalHead}>
            <h3 className={styles.modal_title}> Media Library </h3>
            <button className={styles.btnCloseModal} onClick={handleClose}>
              <FiX />
            </button>
          </div>
          <div className={styles.filter_form}>
            {!is_EnableForm && (
              <div id="imgSearch" className={styles.serachArea}>
                <div className={styles.search_left}> </div>

                <div className={styles.search_right}>
                  <div className={styles.form_group}>
                    <select
                      className={styles.formControl}
                      name="tag"
                      placeholder="Filter by Type"
                      onChange={handleInput}
                      value={searchFields.filter.tag}
                      // onBlur={(e) => handleSearch()}
                    >
                      {allowItem == "All" && (
                        <Fragment>
                          <option value="">All Media</option>
                          <option value="image">Image</option>
                          <option value="pdf">PDF</option>
                          <option value="video">Video</option>
                        </Fragment>
                      )}

                      {allowItem == "image" && (
                        <option value="image">Image</option>
                      )}

                      {allowItem == "pdf" && <option value="pdf">PDF</option>}

                      {allowItem == "video" && (
                        <option value="video">Video</option>
                      )}
                      {allowItem == "audio" && (
                        <option value="audio">Audio</option>
                      )}
                    </select>
                    <small className={styles.formLebel}>Filter by Type</small>
                  </div>
                  <div className={styles.form_group}>
                    <select
                      className={styles.formControl}
                      name="sortOrder"
                      placeholder="Filter by Type"
                      onChange={handleOrder}
                      value={searchFields.sortOrder}
                      // onBlur={(e) => handleSearch()}
                    >
                      <option value="DESC">DESC</option>
                      <option value="ASC">ASC</option>
                    </select>
                    <small className={styles.formLebel}>Short Order</small>
                  </div>
                  <div className={styles.form_group}>
                    <span className={styles.searchicon}>
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      autoComplete="off"
                      className={`${styles.formControl} ${styles.keyword_search} `}
                      name="mediaName"
                      placeholder="Search"
                      value={searchFields.searchText}
                      onChange={handleInput}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch();
                        }
                      }}
                      onBlur={(e) => handleSearch()}
                    />
                    <small className={styles.formLebel}>Filter by name</small>
                  </div>
                  <div className={styles.form_group}>
                    <Button
                      size="small"
                      onClick={(e) => setEnableForm(true)}
                      style={{
                        color: "#fff",
                        borderColor: "#F47F20",
                        backgroundColor: "#F47F20",
                        boxShadow: "none",
                      }}
                      variant="contained"
                      type="button"
                    >
                      <BsCloudUploadFill /> &nbsp;
                      <span className="hide-sm">New</span>
                    </Button>
                  </div>
                </div>
              </div>
            )}

            {is_EnableForm && (
              <div className={styles.serachArea}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={(e) => handleList()}
                  type="button"
                  style={{
                    color: "#fff",
                    borderColor: "#F47F20",
                    backgroundColor: "#F47F20",
                    boxShadow: "none",
                    textTransform: "capitalize",
                  }}
                >
                  <BsFillGrid3X2GapFill /> &nbsp; Back to Galary
                </Button>
              </div>
            )}
          </div>
          <div className={styles.ModalBody}>
            {!is_EnableForm && (
              <div className={styles.grid_container}>
                {mediaData.length > 0 ? (
                  <div className={styles.grid_item}>
                    {(loading ? Array.from(new Array(5)) : mediaData).map(
                      (entity, index) => {
                        if (entity) {
                          return (
                            <MediaBox
                              data={entity}
                              key={`media_${entity.mediaManagerId}`}
                              onClick={imageChange}
                              is_selected={
                                selected &&
                                entity.mediaManagerId == selected.mediaManagerId
                              }
                            />
                          );
                        } else {
                          return <MediaScreen key={`media_${index}`} />;
                        }
                      }
                    )}
                  </div>
                ) : (
                  <div className="no-result-fund"></div>
                )}
              </div>
            )}
            {is_EnableForm && (
              <MediaUPload
                onUploaded={handleUploaded}
                allowItem={allowItem}
                showTitle={false}
              />
            )}
          </div>
          <div className={styles.ModalFooter}>
            {!is_EnableForm && paginate.total > paginate.page_total && (
              <div className={styles.inputPager}>
                <PaginationComponent
                  paginate={paginate}
                  paginationHandler={paginationHandler}
                />
              </div>
            )}
            {!is_EnableForm && (
              <div className={styles.actions}>
                <Button
                  onClick={handleClose}
                  style={{
                    marginLeft: "8px",
                    background: "#F5F8FA",
                    color: "#7E8299",
                    boxShadow: "none",
                  }}
                  type="button"
                  variant="contained"
                  size="small"
                >
                  Close
                </Button>

                <Button
                  name="insertimages"
                  variant="contained"
                  data-srclink={
                    selected && selected.src ? selected.src : imageUrl
                  }
                  onClick={handleInsert}
                  style={{
                    marginLeft: "8px",
                    background: "#F47F20",
                    boxShadow: "none",
                    display: selected && selected.src ? "inline" : "none",
                  }}
                  type="button"
                  size="small"
                >
                  Insert
                </Button>
              </div>
            )}
            {is_EnableForm && (
              <Grid item md={12} sm={12} style={{ textAlign: "right" }}>
                <button
                  onClick={handleClose}
                  className={styles.closeModal}
                  type="button"
                >
                  Close
                </button>
              </Grid>
            )}
          </div>
        </Box>
      </Modal>
    </Fragment>
  );
};
export default MyGallery;
